// apps/account-portal/src/constants/systemDefinitions.ts
// 系統定義的靜態設定（圖示、功能翻譯 key）
// 在頁面元件中搭配 useTranslation 動態產生功能列表文字
import React from 'react';
import { SystemType } from '@redpanda/types';
import {
  UsersIcon,
  CalculatorIcon,
  ClipboardDocumentListIcon,
  IdentificationIcon,
  CalendarDaysIcon,
  TicketIcon,
} from '@heroicons/react/24/outline';

// 單色線條圖示（docs/介面優化.md §3-4：不用 emoji、不加淡色底方塊）
export type SystemIcon = React.ComponentType<{ className?: string }>;

interface SystemConfig {
  system: SystemType;
  icon: SystemIcon;
  featureKeys: string[];
}

export const ENTERPRISE_SYSTEM_CONFIGS: SystemConfig[] = [
  {
    system: 'CRM',
    icon: UsersIcon,
    featureKeys: [
      'customer_management',
      'interaction_tracking',
      'quote_management',
      'project_tracking',
    ],
  },
  {
    system: 'ACCOUNTING',
    icon: CalculatorIcon,
    featureKeys: [
      'journal_entries',
      'tax_calculation',
      'reconciliation',
      'bank_accounts',
      'invoice_management',
      'financial_reporting',
    ],
  },
  {
    system: 'PM',
    icon: ClipboardDocumentListIcon,
    featureKeys: [
      'project_management',
      'requirement_tracking',
      'milestone_management',
      'task_assignment',
      'gantt_chart',
      'file_management',
      'payment_tracking',
    ],
  },
  {
    system: 'HR',
    icon: IdentificationIcon,
    featureKeys: [
      'employee_management',
      'payroll_processing',
      'attendance_tracking',
      'performance_review',
    ],
  },
];

export const STORE_SYSTEM_CONFIGS: SystemConfig[] = [
  {
    system: 'BOOKING',
    icon: CalendarDaysIcon,
    featureKeys: [
      'appointment_management',
      'service_configuration',
      'staff_scheduling',
      'customer_management',
      'analytics_reports',
      'multi_store_support',
    ],
  },
  {
    system: 'QUEUE',
    icon: TicketIcon,
    featureKeys: [
      'online_queue',
      'call_management',
      'display_board',
      'line_notification',
      'analytics_reports',
      'qr_code_queue',
    ],
  },
];

export const ALL_SYSTEM_CONFIGS: SystemConfig[] = [
  ...ENTERPRISE_SYSTEM_CONFIGS,
  ...STORE_SYSTEM_CONFIGS,
];
